/**
 * Created by yoavp on 12/30/2014.
 */


define(function (require) {
    "use strict";

    var TabsView = require("connection-views/TabsView");
    var TabsModel = require("connection-models/TabsModel");
    var CP_CONST = require("connection-const");
    var media = require("media");

    var TabsController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TabsController = Marionette.Controller.extend({
            initialize: function (options) {
                this._connectionPanelContextModel = options.connectionPanelContextModel;
                this._visibility = options.visibility;
                this._generateView();
                this._bindEvents();
                this._manageSelectedTab();
            },

            _manageSelectedTab: function () {
                var that = this;
                if (this.tabsView.getIsRendered()) {
                    this._updateSelectedTab();
                }
                else {
                    this.listenTo(this.tabsView, "render", function () {
                        that._updateSelectedTab();
                    });
                }
            },

            _updateSelectedTab: function () {
                var selectedTab = this._connectionPanelContextModel.getSelectedTab();
                switch (selectedTab) { //chat content
                    case(CP_CONST.TABS.CONTENT):
                        this.tabsView.selectKPsTab();
                        break;
                    case(CP_CONST.TABS.CHAT):
                        this.tabsView.selectChatTab();
                        (media.channel("cp_chat")).vent.trigger("chat:chatTabActivated");
                        break;
                    case(CP_CONST.TABS.TICKET):
                        this.tabsView.selectTicketTab();
                        LEConnection.vent.trigger("TicketTabController::initCollection");
                        break;
                    case(CP_CONST.TABS.NOTIFICATION):
                        this.tabsView.selectNotificationTab();
                        break;
                }
            },

            _generateView: function () {
                this.tabsModel = new TabsModel();
                this.tabsView = new TabsView({
                    model: this.tabsModel,
                    connectionPanelContextModel: this._connectionPanelContextModel,
                    visibility: this._visibility
                });
                LEConnection.vent.trigger("MainContainerController::showRegion:tabsRegion", {
                    view: this.tabsView
                });
            },

            _bindEvents: function () {
                LEConnection.vent.on("TabsController:switchTab", this._switchTab, this);
                this._connectionPanelContextModel.on("change:selectedTab", this._manageSelectedTab, this );
                this._connectionPanelContextModel.on("change:chatNotificationsCounter", this._updateChatTabsModel, this );
                this._connectionPanelContextModel.on("change:notificationCenterEventsCounter", this._updateNotificationTabsModel, this);
                this._connectionPanelContextModel.on("change:hasCriticalNotifications", this._updateNotificationCriticalTabsModel, this);
                this._connectionPanelContextModel.on('change:newKPsCounter', this._updateNewKPsCounter, this);
            },


            _manageChatNotifications: function (chatNotificationsCounter) {
                LEConnection.logger.debug("set the tabsModel chatNotificationsCounter with the number of notifications of  " + chatNotificationsCounter, "TabsController:_manageChatNotifications");
                this.tabsModel.set("chatNotificationsCounter", Number(chatNotificationsCounter.chatNotificationsCounter));
            },

            _switchTab: function (options) {
                LEConnection.logger.info("Switch between tabs ", options.tab);
                if (options && options.tab) {
                    this._connectionPanelContextModel.set("selectedTab", options.tab);
                }
            },

            _updateChatTabsModel: function (model, chatNotificationsCounter) {
                this.tabsModel.set("chatNotificationsCounter", chatNotificationsCounter);
            },

            _updateNotificationTabsModel: function(model, notificationCenterEventsCounter) {
                this.tabsModel.set("notificationCenterEventsCounter", notificationCenterEventsCounter);
            },

            _updateNotificationCriticalTabsModel: function (model, urgents) {
                this.tabsView.notificationCritical(urgents);
            },

            _updateNewKPsCounter: function (model, counter) {
                this.tabsModel.set('newKPsCounter', counter);
            }
        });
    });
    return TabsController;
});



